import Swiper, { Navigation } from 'swiper';

const slider = (() => {
  const init = () => {
    let swiper = new Swiper('.frontPageSwiper', {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.fps-button-next',
        prevEl: '.fps-button-prev',
      },
      breakpoints: {
        567: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  };

  return {
    init,
  };
})();

slider.init();
